<template>
  <b-container id="fiche_container">
    <b-row>
      <b-col>
        <div id="live_submenu">
          <b-button class="inline-submenu-btn with_icon" @click="$router.go(-1)">
            <b-icon icon="arrow-left-circle" aria-hidden="true"></b-icon>
            {{ $t("retour") }}</b-button
          >
          <div class="fb-share-button btn inline-submenu-btn with_icon btn-secondary" :data-href="'https://sportips.fr/race' + $route.fullPath" data-layout="" data-size="">
            <b-icon icon="facebook" aria-hidden="true"></b-icon>
            <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI('https://sportips.fr/race' + $route.fullPath) + '&amp;src=sdkpreparse'" class="fb-xfbml-parse-ignore">Partager</a>
          </div>
          <b-button class="inline-submenu-btn with_icon" @click="addToFavorite" v-if="!is_in_favorites">
            <b-icon icon="star" aria-hidden="true"></b-icon>
            Ajouter aux favoris</b-button
          >
          <b-button class="inline-submenu-btn with_icon" @click="removeFromFavorite" v-else>
            <b-icon icon="star-fill" aria-hidden="true"></b-icon>
            Retirer des favoris</b-button
          >
        </div>
      </b-col>
    </b-row>
    <transition name="fade">
      <b-row>
        <b-col class="content_container">
          <Loading v-if="$store.state.loading"></Loading>
          <div v-if="coureur.dossard && !$store.state.loading" class="align_left">
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 15px; align-items: center">
              <h3>
                <img v-if="coureur.nation != ''" class="flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" />{{ coureur.prenom }} {{ coureur.nom }}
                <span class="primary_color"><b> | </b></span>
                {{ $t("doss") }} n°
                <span class="primary_color">{{ coureur.dossard }}</span>
              </h3>
              <div style="display: flex; flex-direction: row; gap: 5px; align-items: center; margin-top: -5px">
                <div v-if="coureur.itra > 0" class="itra_value">
                  <img src="../assets/Logo_itra_Simple_N blanc.png" alt="itra" class="itra_logo_filter" /> <span style="font-size: 1rem">{{ coureur.itra }}</span>
                </div>
                <div class="cote_sportips_value" v-else-if="parseInt(coureur.cotation) != 50">
                  <img src="../assets/sportips.png" alt="sportips" class="itra_logo_filter" /> <span style="font-size: 1rem">{{ parseInt(coureur.cotation) }}</span>
                </div>
                <b-icon icon="arrow-right" aria-hidden="true" v-if="!coureur.statut.depart && parseInt(coureur.cotation) != 50"></b-icon>
                <b-button v-if="!coureur.statut.depart && parseInt(coureur.cotation) != 50" class="inline-submenu-btn with_icon btn-secondary" style="margin: 0 !important" @click="displayEstimationTable()">
                  <span v-if="!display_estimation">Afficher mon estimation</span><span v-else>Masquer mon estimation</span></b-button
                >
              </div>
              <InfoLocalisation :methode="coureur.tracking_methode"></InfoLocalisation>
              <div style="margin-left: auto">
                <SelectFondMap></SelectFondMap>
              </div>
            </div>
            <div style="display: flex; flex-direction: row">
              <div class="fiche_status" v-if="coureur.statut.text.includes('En course')">
                <p class="status_arrive" v-if="temps_de_course">En course : {{ temps_de_course }}</p>
              </div>
              <div v-else class="fiche_status" style="margin-bottom: 10px !important">
                <p v-if="coureur.statut.text.includes('Arrivé')" class="status_arrive"><v-icon name="check" /> {{ coureur.statut.text }}</p>
                <p v-else-if="coureur.statut.text.includes('Abandon') || coureur.statut.text.includes('Disqualifié')" class="status_abandon"><v-icon name="times" /> {{ coureur.statut.text }}</p>
                <p v-else class="status_autre"><v-icon name="ellipsis-h" />{{ coureur.statut.text }}</p>
              </div>
            </div>

            <p class="darkgrey_color">
              <span v-if="coureur.depart != '' && coureur.statut.depart"
                >Départ : <b>{{ coureur.depart }} | </b></span
              >
              <span v-else-if="coureur.depart != '' && coureur.heure_depart_theorique"
                >Départ prévu : <b>{{ coureur.heure_depart_theorique }} | </b></span
              >
              {{ $t("course") }} : <b>{{ coureur.course }} | </b> {{ $t("categorie") }} : <b>{{ coureur.cat }} | </b> {{ $t("club") }} :
              <b v-if="coureur.club.length > 0">{{ coureur.club }}</b>
              <b v-else>-</b>
            </p>
            <InfosPCCourseFiche v-if="$store.state.logged" :coureur="coureur"></InfosPCCourseFiche>

            <PassagesCoureur v-if="!display_estimation" :passages="coureur.points" :statut="coureur.statut"></PassagesCoureur>
            <EstimationPassagesCoureur v-else :passages="coureur.points" :coureur="coureur"></EstimationPassagesCoureur>
            <MapCoureur v-if="lines.length > 0" :lines="lines" :coureur="coureur" :focus_point="focus_point"></MapCoureur>
            <ProfilCoureur v-if="lines.length > 0" :lines="lines" :coureur="coureur" :focus_point="focus_point" v-on:focus_point="setFocusPoint"></ProfilCoureur>
          </div>
          <div v-if="!coureur.dossard && !$store.state.loading">
            <h3>{{ $t("fiche.erreur_chargement") }}</h3>
            <router-link to="live"
              ><b-button class="inline-btn">{{ $t("retour") }}</b-button></router-link
            >
          </div>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import axios from "axios";
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import PassagesCoureur from "@/components/Live_tab/PassagesCoureur.vue";
import EstimationPassagesCoureur from "@/components/Live_tab/EstimationPassagesCoureur.vue";
import InfosPCCourseFiche from "@/components/Live_tab/PCCourse/InfosPCCourseFiche.vue";
import MapCoureur from "@/components/Live_tab/MapCoureur.vue";
import ProfilCoureur from "@/components/Live_tab/ProfilCoureur.vue";
import InfoLocalisation from "@/components/Live_tab/InfoLocalisation.vue";
import Loading from "@/components/Loading.vue";
import SelectFondMap from "@/components/FondMapSelector.vue";
export default {
  components: {
    PassagesCoureur,
    MapCoureur,
    ProfilCoureur,
    Loading,
    InfoLocalisation,
    SelectFondMap,
    InfosPCCourseFiche,
    EstimationPassagesCoureur,
  },

  data() {
    return {
      display_estimation: false,
      coureur: {},
      focus_point: 0,
      lines: [],
      updateIn: 90,
      temps_de_course: "",
      favoris: [],
    };
  },
  computed: {
    is_in_favorites() {
      return this.favoris.includes(this.coureur.id);
    },
  },

  methods: {
    displayEstimationTable() {
      this.display_estimation = !this.display_estimation;
    },
    addToFavorite() {
      if (!this.favoris.includes(this.coureur.id)) {
        this.favoris.push(this.coureur.id);
      }
      this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
    },
    removeFromFavorite() {
      var index = this.favoris.indexOf(this.coureur.id);
      this.favoris.splice(index, 1);
      this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
    },
    setFocusPoint(p) {
      this.focus_point = p;
    },
    buildLines() {
      var _this = this;
      axios.get("https://sportips.fr/live/" + this.coureur.parcours.trace).then(function (response) {
        var geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
        _this.lines = geojson.features[0].geometry.coordinates;
      });
    },
    tempsCourseRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshTempsCourseIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshTempsCourseIntervals");
        var date_depart = _this.coureur.date_course.split("-");
        var heure_depart = _this.coureur.depart.split(":");
        if (date_depart.length > 2 && heure_depart.length > 2) {
          var timestamp_depart = new Date(date_depart[2], parseInt(date_depart[1]) - 1, date_depart[0], heure_depart[0], heure_depart[1], heure_depart[2]);
          var timestamp_now = Date.now();
          var temps_course = (timestamp_now - timestamp_depart) / 1000;
          _this.temps_de_course = _this.seconds2time(parseInt(temps_course));
        }
        _this.tempsCourseRefresh();
      }, 1000);
      this.$store.state.refreshTempsCourseIntervals.push(intervalObject);
    },

    seconds2time(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      var seconds = seconds - hours * 3600 - minutes * 60;
      var time = "";

      if (hours != 0) {
        hours = hours < 10 ? "0" + hours : String(hours);
        time = hours + ":";
      } else {
        time = "00:";
      }
      if (minutes != 0 || time !== "") {
        minutes = minutes < 10 && time !== "" ? "0" + minutes : String(minutes);
        time += minutes + ":";
      } else {
        time += "00:";
      }
      if (time === "") {
        time = seconds + "s";
      } else {
        time += seconds < 10 ? "0" + seconds : String(seconds);
      }
      return time;
    },
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchCoureurData();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    fetchCoureurData() {
      var _this = this;
      let url = this.$store.state.base_url + "/coureur/get.php?id_module=" + this.$store.state.module.id + "&id=" + this.$route.params.id_coureur;
      if (this.$store.state.logged) {
        url += "&pc_course=1";
      }
      axios.get(url).then(function (response) {
        _this.$store.commit("unsetLoading");
        console.log("LIVE -- Fetch fiche ");
        if (response.data !== "") {
          _this.coureur = response.data;

          if (_this.coureur.parcours.trace && _this.lines.length === 0) {
            _this.buildLines();
          }
        }
      });
    },
    loadFavoris() {
      let key = "favorites_" + this.$store.state.module.base;

      if (this.$cookies.isKey(key)) {
        let favs = this.$cookies.get(key);
        if (favs) {
          this.favoris = favs.split(",");
        } else {
          this.$cookies.set(key, []);
        }
      } else {
        this.$cookies.set(key, []);
      }
    },
  },
  mounted() {
    this.loadFavoris();
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
    this.$store.commit("setLoading");
    this.fetchCoureurData();
    this.countdownRefresh();
    this.tempsCourseRefresh();
    this.$forceUpdate();
  },
};
</script>

<style lang="scss" scoped>
</style>